import {TestGroupStudentsModel, TestModel} from '../../../types';

export function isTestGroupStudentsModel(test: TestModel): test is TestGroupStudentsModel {
	return 'studentsResult' in test;
}
